/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Standalone OpenAPI 3.0 schema: nullable must accompany the object type,
 * rather than wrap a reference to a schema that excludes null.
 * @export
 * @interface NullableMoneyOutput
 */
export interface NullableMoneyOutput {
    /**
     * 
     * @type {string}
     * @memberof NullableMoneyOutput
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof NullableMoneyOutput
     */
    currency?: string;
}

/**
 * Check if a given object implements the NullableMoneyOutput interface.
 */
export function instanceOfNullableMoneyOutput(value: object): value is NullableMoneyOutput {
    return true;
}

export function NullableMoneyOutputFromJSON(json: any): NullableMoneyOutput {
    return NullableMoneyOutputFromJSONTyped(json, false);
}

export function NullableMoneyOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): NullableMoneyOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function NullableMoneyOutputToJSON(json: any): NullableMoneyOutput {
    return NullableMoneyOutputToJSONTyped(json, false);
}

export function NullableMoneyOutputToJSONTyped(value?: NullableMoneyOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'currency': value['currency'],
    };
}

